import produce from 'immer';
import * as Action from '../actions/index';
export const initialState = {
  backend: {
    reservationList: null,
  },
  allreservations: null,
  frontend: {
    myReservations: null,
  },
};

const reducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case Action.CREATE_RESERVATION:
        return state;
      case Action.GET_ALLRESERVATIONS:
        draft.backend.reservationList = action.payload;
        break;
      case Action.DELETE_RESERVATION:
        const reservationId = action.payload;
        const resesrvationIndex = draft.backend.reservationList.findIndex(
          (el) => el.id === reservationId
        );
        draft.backend.reservationList.splice(resesrvationIndex, 1);
        break;
      default:
        return state;
    }
  });
export default reducer;
